import HorizontalMenu from './horizontalMenu'

export default HorizontalMenu
